export function buttonActionFunc() {
  let letSpSetTxt, letJsEachNav;
  letSpSetTxt = $('#spSetTxt');
  letJsEachNav = $('#jsEachNav').find('a.currentOn').text();
  letSpSetTxt.text(letJsEachNav);

  let resizecheck = $('#responsibleCheck').width();
  let resizecheck2 = 0;

  $(window).on('load resize', function () {
    resizecheck = $('#responsibleCheck').width();
    jsEachNavResetStart();
  });

  letSpSetTxt.on('click', function () {
    $(this).toggleClass('isOpen');
    $(this).next().stop().slideToggle(500);
  });

  var jsEachNavResetStart = function () { //アコーディオンの状態の初期化
    let resizecheck = $('#responsibleCheck').width();
    if (resizecheck == '2' && resizecheck != resizecheck2) { //SPの時のみ
      letSpSetTxt.next('dd').css('display', 'none');

      resizecheck2 = 2;
    } else if (resizecheck == '1' && resizecheck != resizecheck2) {
      letSpSetTxt.removeClass('isOpen');
      letSpSetTxt.next('dd').css('display', 'block');

      resizecheck2 = 1;
    }
  }
  jsEachNavResetStart();
}

export function zoomInFunc() {

  let letZoomBtn, letImgBox, letModalImg, letZoomBtn02, letImgBox02, letModalImg02, letMapBtn;
  letZoomBtn = $('.zoomBtn');
  letImgBox = $('.imgBox');
  letModalImg = $('.modalImg');
  letMapBtn = $('.mapBtn');

  letZoomBtn.on('click', function () {
    $(this).parent(letImgBox).addClass('open');
    if (letImgBox.hasClass('open')) {
      $("#header").fadeOut();
      $(".breadcrumb").fadeOut();
      $(".scrPageTop").fadeOut();
    }
  });
  
  letModalImg.on('click',function () {
    if(!$(event.target).closest('img , p').length) {
      $(this).parent(letImgBox).removeClass('open');
      $("#header").show();
      $(".breadcrumb").show();
      $(".scrPageTop").show();

      $(this).find('.mapImage').removeClass('hide');
      letMapBtn.parents('.attention').removeClass('hide');
      $(this).find('.mapScaleImage').addClass('hide');
      $(this).find('.backMapBtn').addClass('hide');
    }
  });

  letZoomBtn02 = $('.modalBtn');
  letImgBox02 = $('.imgModalBox');
  letModalImg02 = $('.modalImg02');

  letZoomBtn02.on('click', function () {
    $(letImgBox02).addClass('open');
    if (letImgBox02.hasClass('open')) {
      $("#header").fadeOut();
      $(".breadcrumb").fadeOut();
      $(".scrPageTop").fadeOut();
    }
  });
  
  letModalImg02.on('click',function () {
    if(!$(event.target).closest('img , p').length) {
      $(this).parents(letImgBox02).removeClass('open');
      $("#header").show();
      $(".breadcrumb").show();
      $(".scrPageTop").show();
    }
  });

  letMapBtn.on('click', function () {
    $(this).parents(letModalImg).find('.mapImage').addClass('hide');
    $(this).parents(letModalImg).find('.mapScaleImage').removeClass('hide');
    $(this).parents(letModalImg).find('.backMapBtn').removeClass('hide');
    $(this).parents('.attention').addClass('hide');
  });
  $('.backMapBtn').on('click', function () {
    $(this).parents(letModalImg).find('.mapImage').removeClass('hide');
    $(this).parents(letModalImg).find('.attention').removeClass('hide');
    $(this).parents(letModalImg).find('.mapScaleImage').addClass('hide');
    $(this).addClass('hide');
  });
}